import React from "react";

/**
 * Renders a before/after diff using SequenceMatcher-style opcodes returned by backend.
 * blocks: [{type: 'equal'|'insert'|'delete'|'replace', before: [..], after: [..]}]
 */
export default function DiffView({ diff, currentUrl }) {
  if (!diff || !diff.blocks) {
    return (
      <div className="text-sm text-[hsl(var(--ink-muted))]" data-testid="diff-empty">
        No side-by-side comparison available for this section.
      </div>
    );
  }
  const { blocks, stats } = diff;

  return (
    <div className="space-y-3" data-testid="diff-view">
      <div className="flex items-center justify-between text-xs font-mono uppercase tracking-wider text-[hsl(var(--ink-muted))]">
        <div className="flex items-center gap-3">
          <span>
            <span className="text-[hsl(var(--accent-green))] font-semibold">+{stats?.added ?? 0}</span> added
          </span>
          <span>
            <span className="text-[hsl(var(--stamp-red))] font-semibold">−{stats?.removed ?? 0}</span> removed
          </span>
          <span>
            {stats?.unchanged ?? 0} kept
          </span>
        </div>
        {currentUrl && (
          <a
            href={currentUrl}
            target="_blank"
            rel="noreferrer"
            className="text-[hsl(var(--accent-blue))] hover:underline normal-case"
            data-testid="diff-current-law-link"
          >
            current law source ↗
          </a>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border border-[hsl(var(--rule))] rounded-sm overflow-hidden">
        <div className="bg-[hsl(var(--paper-2))] p-2 border-b md:border-b-0 md:border-r border-[hsl(var(--rule))]">
          <div className="section-label mb-2">Current law</div>
          <div className="font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words">
            {blocks.map((b, i) => {
              if (b.type === "insert") return null;
              const cls =
                b.type === "delete" ? "diff-del" :
                b.type === "replace" ? "diff-del" : "diff-eq";
              return (b.before || []).map((ln, j) => (
                <div key={`${i}-${j}`} className={`${cls} px-2 py-0.5 my-0.5`}>{ln}</div>
              ));
            })}
          </div>
        </div>
        <div className="bg-white p-2">
          <div className="section-label mb-2">Proposed text</div>
          <div className="font-mono text-[13px] leading-relaxed whitespace-pre-wrap break-words">
            {blocks.map((b, i) => {
              if (b.type === "delete") return null;
              const cls =
                b.type === "insert" ? "diff-add" :
                b.type === "replace" ? "diff-add" : "diff-eq";
              return (b.after || []).map((ln, j) => (
                <div key={`${i}-${j}`} className={`${cls} px-2 py-0.5 my-0.5`}>{ln}</div>
              ));
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
